<template>
  <div class="sp-template">
    <div class="h-title">供应商统计报表</div>
    <el-card class="box-card">
      <!-- <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-form-item label="供应商">
						<el-select v-model="queryForm.supplierId" filterable clearable>
              <el-option v-for="item in suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item >
            <div class="search-form__buttons">
              <el-button v-if="in_configs(80501)" type="primary" size="small" @click="searchTask">搜 索</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div> -->
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button v-if="in_configs(80502)" size="small" @click="exportExcel(1)">导出</el-button>
        </div>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column prop="supplier" label="供应商"></el-table-column>
        <el-table-column prop="previousNoPayment" label="历史未付"></el-table-column>
        <el-table-column prop="currentMonthNoPayment" label="当月未付"></el-table-column>
        <el-table-column prop="totalNoPayment" label="累计未付"></el-table-column>
      </el-table>

      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryForm.currentPage" :page-sizes="pageSizes" :page-size="queryForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

      <form action="" method="get" target="_blank" id="myform"></form>
    </el-card>
  </div>
</template>

<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
export default {
  data() {
    return {
      tableData: [],
      queryForm: {
        supplierId: "",
        startDate: "",
        endDate: "",
        pageSize: 10,
        currentPage: 1
      },
      suppliers: [],
      supplierMap: {},
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      total: 0
    };
  },
  created() {
    setTimeout(() => {
      this.querySupplierReport();
      this.querySupplier();
    }, 800);
  },
  methods: {
    //搜索
    searchTask() {
      this.queryForm.currentPage = 1;
      this.querySupplierReport();
    },
    querySupplierReport() {
      this.queryForm.export = 0;
      this.$request1
        .post(
          '/report/supplier',
          this.queryForm,
          {
            timeout: 10000,
            withCredentials: true,
            // headers: {
            //   "content-type": "application/x-www-form-urlencoded"
            // }
          }
        )
        .then(response => {
          if (response.data.success) {
            this.total = response.data.total;
            this.tableData = response.data.data;
          } else {
            this.total = 0;
            this.tableData = [];
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {});
    },
    // 供应商名称
    querySupplier() {
      this.$request1({
        method: 'GET',
        url: '/supplier'
      })
        .then(response => {
          this.suppliers = response.data;
          if (this.suppliers != null && this.suppliers.length > 0) {
            this.suppliers.forEach(item => {
              this.supplierMap[item.id] = item.name;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    exportExcel(val) {

      let _this = this;
      _this.queryForm.export = val;


      this.$request1({
        url: '/report/supplier',
        method: 'post',
        data: this.queryForm,
        responseType: 'blob'
      }).then(res => {
        _this.queryForm.export = 0
        const link = document.createElement('a')
        // let array = base64ToUint8Array(res.data)
        // let blob = new Blob([array])
        let blob = new Blob([res.data])
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
        link.setAttribute('download', `supplier_report_${timestr}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })

      // var url = tmsSpringUrl + '/report/supplier';
      // var form = document.getElementById("myform");
      // form.setAttribute("action", url);
      // var fhtml = "";
      // for (var key in this.queryForm) {
      //   fhtml +=
      //     '<input type="hidden" name="' +
      //     key +
      //     '" value="' +
      //     this.queryForm[key] +
      //     '" />';
      // }
      // fhtml +=
      //   '<input type="hidden" name="token" value="' +
      //   this.$getToken() +
      //   '" />';
      // form.innerHTML = fhtml;
      // form.submit();
    },
    //分页
    handleSizeChange(val) {
      this.queryForm.currentPage = 1;
      this.queryForm.pageSize = val;
      this.querySupplierReport();
    },
    handleCurrentChange(val) {
      this.queryForm.currentPage = val;
      this.querySupplierReport();
    },
    formatDate(date, fmt) {
      if (!date) {
        return "";
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2
              ? "/u661f/u671f"
              : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-card__header .el-form .el-input {
  width: 205px;
}
</style>


// WEBPACK FOOTER //
// src/views/report/supplier.vue